'use client';
/* Built In Imports */
import { useEffect, useState } from 'react';

/* External Imports */
import { Link } from '@chakra-ui/next-js';
import {
  Box,
  Button,
  Flex,
  Heading,
  Icon,
  Image,
  Text,
} from '@chakra-ui/react';

import { render } from 'datocms-structured-text-to-html-string';
import YouTube from 'react-youtube';
/* Internal Imports */
/* Components */
import { getEmbedUrl, refineUrlDomain } from '@app-ps/Components/Utility/utils';
import StructuredTextParser from '@app-ps/Utility/StructuredTextParser';
import config from '@config';

/* Services */

/**
 * Renders Productions Component
 * @param {Object} sectionContent - Data from api
 * @param {string} region - Region of the page
 * @param {string} lang - Language of the page
 * @returns {ReactElement} - Productions Component
 */

const Productions = ({ sectionContent, lang, region }) => {
  const [vidVis, setVidVis] = useState(false);
  const [opts, setOpts] = useState({});

  useEffect(() => {
    setOpts({
      height: document.getElementById('msr-vid')?.clientHeight || 315,
      width: '100%',
      playerVars: {
        autoplay: 1,
      },
    });
  }, [global?.window]);

  const onReady = event => {
    event.target.playVideo();
  };
  return (
    <Box
      backgroundColor="#010509"
      maxW="100%"
      color="white"
      mt={{ base: '-10rem', md: '0' }}
      position="relative"
    >
      <Box
        position="absolute"
        zIndex="12"
        top={{
          base: '-24%',
          sm: '2%',
          md: '-15%',
          lg: '-2%',
          xl: '0',
          '2xl': '-4%',
        }}
        left={{
          base: '1rem',
          sm: '1.5rem',
          md: '3rem',
          lg: '5rem',
          xl: '8rem',
        }}
        width={{
          base: '4rem',
          sm: '5.516rem',
          lg: '12.938rem',
          md: '104px',
          lg: '120px',
          '2xl': '207px',
        }}
        height={{
          base: '176px',
          sm: '10rem',
          md: '279px',
          lg: '420.76px',
          '2xl': '554px',
        }}
      >
        <Image
          src="https://static.sadhguru.org/d/46272/1731238154-prod1330kolam-performances.png"
          alt="flower-yellow"
          width="full"
          height="full"
        />
      </Box>
      <Flex
        textAlign="center"
        pt={{
          base: '0rem',
          sm: '8rem',
          md: '0rem',
          lg: '5rem',
          xl: '12rem',
          '2xl': '15rem',
        }}
        width={{ base: '100%', md: '100%' }}
        // height="10rem"
        alignItems="center"
        justifyContent="center"
        maxW="724px"
        m={{ base: '-3rem auto 0', md: '0 auto' }}
        flexDir="column"
      >
        {sectionContent[0]?._modelApiKey === 'section_title' && (
          <Heading
            color="#F18128"
            fontFamily="var(--FedraSerifDisplay-Bold)"
            fontWeight="700"
            fontSize={{
              base: '1.75rem',
              md: '2.25rem',
              lg: '42px',
              '2xl': '3.25rem',
            }}
            lineHeight={{ base: '2.1rem', md: '2.7rem', lg: '3.9rem' }}
          >
            {sectionContent[0]?.titleText}
          </Heading>
        )}
        {sectionContent[1]?._modelApiKey === 'structured_text' && (
          <Box>
            <StructuredTextParser
              str={render(sectionContent[1]?.body.value)}
              region={region}
              lang={lang}
              textAlign="center"
              fontFamily="var(--FedraSansStd-book)"
              fontWeight="400"
              fontSize={{ base: '0.875rem', lg: '1.125rem', '2xl': '1.25rem' }}
              lineHeight={{ base: '1.4rem', lg: '28.8px', '2xl': '2rem' }}
              width={{ base: '90%', md: '65%', lg: '90%', '2xl': '100%' }}
              color="#FFFFFF"
              ml="auto"
            />
            <Text mt={4}>
              <Link
                fontFamily="var(--FedraSansStd-medium)"
                fontWeight="500"
                fontSize="1rem"
                lineHeight="1.6rem"
                color="#F18128"
                display="flex"
                justifyContent="center"
                _hover={{ textDecoration: 'none' }}
                href={refineUrlDomain(sectionContent[2]?.linkUrl, region, lang)}
                prefetch
              >
                {sectionContent[2]?.buttonText}
                {/* <span as="span" ml="0.5rem"> */}
                <Icon mt="7px" height="1.5em" w="1.5em" ml=".5rem">
                  <path
                    d="M10.5 1L17.5 7.99998L10.5 15M0.5 7.99998L17 8"
                    stroke="#F18128"
                    strokeWidth="2"
                  />
                </Icon>
                {/* <svg
                  width="19"
                  height="16"
                  viewBox="0 0 19 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  
                </svg> */}
                {/* <ArrowForwardIcon w={'1.063rem'} h={'1.25rem'} /> */}
                {/* </span> */}
              </Link>
            </Text>
          </Box>
        )}
        {sectionContent[4]?._modelApiKey === 'simple_button' &&
          sectionContent[4]?.linkUrl && (
            <Button
              zIndex={1}
              as={Link}
              width={{ base: '328px', md: '158px', lg: '250px' }}
              maxW="95%"
              height={{ lg: '61px', md: '50px', base: '50px' }}
              fontWeight={500}
              backgroundColor="#F18128"
              mt="1.5rem"
              letterSpacing={'0.32px'}
              mb={{ base: '0.5rem', md: '0rem' }}
              borderRadius={'none'}
              padding={{
                base: '0.75rem 2rem',
                md: '1.5rem 1rem',
                lg: '1.5rem 2.5rem',
              }}
              color="#010509"
              fontFamily="var(--FedraSansStd-medium)"
              fontSize={{ md: '1rem', lg: '1.125rem' }}
              lineHeight="1.8rem"
              _hover={{ border: 'none', textDecoration: 'none' }}
              href={refineUrlDomain(sectionContent[4]?.linkUrl, region, lang)}
            >
              {sectionContent[4]?.buttonText}
            </Button>
          )}
      </Flex>
      {sectionContent[3]?._modelApiKey === 'media_embed' && (
        <Box
          position="relative"
          mx="auto"
          id="msr-vid"
          minH={{ base: '375px' }}
          width={{ base: '100%', md: '100%' }}
          height={{ base: '100%', lg: '48.313rem', '2xl': '49.313rem' }}
          backgroundSize={{
            base: 'cover',
            md: 'cover',
            lg: 'cover',
            '2xl': 'cover',
          }}
          backgroundColor="#000"
          backgroundRepeat="no-repeat"
          backgroundPosition="center"
          backgroundImage={sectionContent[3]?.image?.url}
          px={{ base: '1rem', lg: '0rem', md: '0' }}
          mt={{ base: '1rem' }}
        >
          <Image
            src={`${config.imgPath}/d/46272/1722867211-frame-43.png`}
            width={{ base: '70px', lg: '140px' }}
            height={{ base: '70px', lg: '140px' }}
            position="absolute"
            top={{ base: '40%' }}
            cursor="pointer"
            left={{ base: '47%', lg: '46%' }}
            objectFit="cover"
            onClick={() => setVidVis(!vidVis)}
          />

          {vidVis && (
            <Box
              maxW="100%"
              w="full"
              pos="absolute"
              top="0"
              left={0}
              right={0}
              bottom={0}
              h="100%"
              zIndex="1"
            >
              <YouTube
                videoId={getEmbedUrl(sectionContent[3]?.embedUrl)}
                onReady={e => e.target.playVideo()}
                opts={opts}
                loading="lazy"
              />
            </Box>
          )}
          {!vidVis && (
            <Box
              position="absolute"
              top="0"
              left="0"
              right="0"
              height="50%"
              background="linear-gradient(180deg, #010509 0%, rgba(1, 5, 9, 0) 100%)"
              zIndex="10"
              pointerEvents="none"
            />
          )}
          {/* {!vidVis && (
            <Box
              position="absolute"
              bottom="0"
              left="0"
              right="0"
              height="50%"
              // background="linear-gradient(0deg, #010509 0%, rgba(1, 5, 9, 0) 100%)"
              zIndex="10"
              pointerEvents="none"
            />
          )} */}
        </Box>
      )}

      {sectionContent[6]?._modelApiKey === 'structured_text' && (
        <Box
          m={{
            base: '0 auto 0 auto',
            md: '0 auto 3rem auto',
            xl: '-4rem auto 3rem auto',
            '2xl': '0 auto 3rem auto',
          }}
          maxW={{ base: '328px', md: '340px', lg: '824px' }}
          // mb="30px"
          position={{ lg: 'relative', '2xl': 'static' }}
          z-index={'1000'}
          bottom={{ lg: '3rem', '2xl': '9rem' }}
        >
          <StructuredTextParser
            str={render(sectionContent[6]?.body.value)}
            region={region}
            lang={lang}
            css={{
              p: {
                zIndex: 1000,
                position: 'relative',
              },
            }}
            fontSize={{ base: '0.875rem', md: '.9rem', lg: '1.5rem' }}
            lineHeight={{ base: '1.4rem', md: '1.5rem', lg: '2.4rem' }}
            textAlign="center"
            fontFamily="var(--FedraSansStd-book)"
            fontWeight="400"
            p={{ base: 2, lg: 4 }}
            px={{ lg: '7rem' }}
            color="#FFFFFF"
          />
        </Box>
      )}
    </Box>
  );
};

export default Productions;
